<div class="sub-container">

    <!-- <div class="row"> -->
    <div class="custom-card">
        <div class="card radius" *ngFor="let item of data">
            <div class="card-body" [style.backgroundColor]="item.color">
                <!-- <div class="custom-card"> -->
                <!-- <div class="m-r-20 align-self-center"><img src="assets/images/icon/income.png" alt="Income" /></div> -->
                <div class="align-self-center">
                    <h2 class="count-props">{{item.value}}</h2>
                    <h6 class="title-props  m-b-0">{{item.title}}</h6>
                </div>
                <!-- </div> -->
            </div>
        </div>
        <!-- </div> -->
        <!-- <div class="col-lg-3">
            <div class="card radius">
                <div class="card-body color-card2">
                    <div class="custom-card">
                        <div class="align-self-center">
                            <h2 class="m-t-0 count-props">20,000</h2>
                            <h6 class="title-props  m-b-0">No. of services</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3">
            <div class="card radius">
                <div class="card-body color-card3">
                    <div class="custom-card">
                        <div class="align-self-center">
                            <h2 class="m-t-0 count-props">500</h2>
                            <h6 class="title-props  m-b-0">Bookings</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3">
            <div class="card radius">
                <div class="card-body color-card4">
                    <div class="custom-card">
                        <div class="align-self-center">
                            <h2 class="m-t-0 count-props">10</h2>
                            <h6 class=" m-b-0 title-props">Abuse count</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</div>